import { useCallback, useEffect, useState } from 'react';
import { homeAPI } from 'src/api/home-api';
// api
import { vuonTrongApiService } from 'src/api/vuontrong-api';
import { OptionModel } from 'src/types/api-response';
// types
import { VuonTrong } from 'src/types/vuontrong';

// ----------------------------------------------------------------------

type ErrorType = string | null;

export default function useVuonTrong() {
  const [gardens, setGardens] = useState<VuonTrong[]>([]);
  const [garden, setGarden] = useState<VuonTrong | null>(null);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<ErrorType>(null);
  const [optiongardens, setOpetionGardens] = useState<OptionModel[]>([]);
  
  const getVuonTrongs = useCallback(async (query?: string) => {
    try {
      setLoading(true);
      setError(null);
      const response = await vuonTrongApiService.listVuonTrong(
        query ? { searchby: query } as any : undefined
      );
      const items = (response.items as unknown as VuonTrong[]) || [];
      setGardens(items);
    } catch (err: any) {
      setError(err?.message || 'Có lỗi xảy ra khi tải danh sách vườn trồng');
      console.error('Error fetching gardens:', err);
    } finally {
      setLoading(false);
    }
  }, []);
  const getOptionVuonTrong = useCallback(async (query?: string) => {
    try {
      setLoading(true);
      setError(null);
      const response = await homeAPI.OptionVuonTrong();
      const items = (response.items as OptionModel[]) || [];
      setOpetionGardens(items);
    } catch (err: any) {
      setError(err?.message || 'Có lỗi xảy ra khi tải danh sách vườn trồng');
      console.error('Error fetching gardens:', err);
    } finally {
      setLoading(false);
    }
  }, []);
  const refresh = useCallback(() => {
    getVuonTrongs();
  }, [getVuonTrongs]);

  const search = useCallback(async (query: string) => {
    await getVuonTrongs(query);
  }, [getVuonTrongs]);

  const deleteVuonTrong = useCallback(async (id: number) => {
    try {
      const response = await vuonTrongApiService.deleteVuonTrong(id);
      if (response?.messCode === 7) {
        const idArray = Array.isArray(id) ? id : [id];
        setGardens((prev) => prev.filter((gardenItem) => !idArray.includes(gardenItem.vuonTrong_ID!)));
        if (garden && idArray.includes(garden.vuonTrong_ID!)) {
          setGarden(null);
        }
        return true;
      }
      throw new Error(response?.message || 'Xóa vườn trồng thất bại');
    } catch (err) {
      console.error('Error deleting garden:', err);
      throw err;
    }
  }, [garden]);

  useEffect(() => {
    getVuonTrongs();
  }, [getVuonTrongs]);

  return {
    gardens,
    garden,
    loading,
    error,
    optiongardens,
    getOptionVuonTrong,
    getVuonTrongs,
    refresh,
    search,
    deleteVuonTrong,
    setGarden,
  };
}


